import { render, staticRenderFns } from "./CoordinationConversionAttributeConfirmTable.vue?vue&type=template&id=2bcecf24&scoped=true"
import script from "./CoordinationConversionAttributeConfirmTable.vue?vue&type=script&lang=ts"
export * from "./CoordinationConversionAttributeConfirmTable.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationConversionAttributeConfirmTable.vue?vue&type=style&index=0&id=2bcecf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcecf24",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/client-settings/coordination/conversion-attribute/coordination-conversion-attribute-confirm-table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fcoordination%2Fconversion-attribute%2FCoordinationConversionAttributeConfirmTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports